import withReferenceCounter from "./withReferenceCounter";
import nullthrows from "./nullthrows";
// These input method listeners help us design more accessible experiences for
// our users.
//
// While browser and CSS APIs provide us with methods to determine when an
// element is focused, they don’t specify the input method used to focus the
// element. Knowing the input method allows us to change an element’s
// appearance: for example, keyboard navigation often requires additional
// visual affordances (while mouse and touch navigation have built-in visual
// aids).
//
// Unfortunately, we can’t just listen to events on a per-element basis:
// while the `focus` event includes the prior target in the `relatedTarget`
// property, it does not specify the input method (which occurs as an event
// on the prior element). Since only one element can be focused at a time
// within the browser, we track the input method as global state.
const createInputMethodListeners = () => {
  const body = () => nullthrows(document.body);
  let lastMethod = 'mouse';
  const setMethod = method => () => {
    lastMethod = method;
  };
  const setKeyboard = setMethod('keyboard');
  const setMouse = setMethod('mouse');
  const setTouch = setMethod('touch');
  const {
    mount,
    unmount
  } = withReferenceCounter({
    mount: () => {
      // We use the capture phase to observe all keydown, mousedown, and
      // touchstart events on the body before they’re handled by other code.
      //
      // Learn more about event bubbling and the capture phase here:
      //   https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture
      body().addEventListener('keydown', setKeyboard, true);
      body().addEventListener('mousedown', setMouse, true);
      body().addEventListener('touchstart', setTouch, true);
    },
    unmount: () => {
      body().removeEventListener('keydown', setKeyboard, true);
      body().removeEventListener('mousedown', setMouse, true);
      body().removeEventListener('touchstart', setTouch, true);
    }
  });

  // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'InputMethod'.
  return {
    mount,
    unmount,
    getState: () => lastMethod
  };
};
const inputMethod = createInputMethodListeners();
export default inputMethod;